export interface IBodegasPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: BODEGAS[];
}

export interface BODEGAS {
  id_bodega?: string;
  nombre?: string;
  codigo: string;
  direccion?: string;
  estado?: boolean;
  es_externa?: boolean;
  empresa?: string;
  pais?: string;
  ciudad?: string;
  provincia?: string;
  zona?: string;
  sector?: string;
  es_cliente?: boolean
  es_transito?:boolean
  es_concecion_cliente?:boolean
  email?: string | null;
}

export interface BodegasParams extends Partial<BODEGAS>{

}


export enum BodegasCodeEnum {
  EXTERNA = 'BDEX',
}
export enum TiposBodegaEnum{
  BODEGA_MATRIZ_QUITO='BODEGA_MATRIZ_QUITO'
}